module.exports = __webpack_public_path__ + "static/img/4.f3d735d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/8/zh/4.png
// module id = d6hl
// module chunks = 0